module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp23_9005.388835d3.png";